<template>
  <div
    v-if="displayIndex"
    id="h4hHotelIndex"
    class="event"
  >
    <div
      id="updateOrderCurrency"
      class="update-order-currency"
      bind="value:name"
      @click="updateOrderCurrency($event)"
    />
    <transition name="fade">
      <div
        v-if="this.$store.state.hotel.loading"
        class="initial-hotels-load"
      />
    </transition>
    <div class="retail-hotel-filter-container mobile-filter">
      <HotelFilter />
    </div>
    <div
      v-if="this.$store.state.hotel.showMap && !this.$store.state.hotel.loading"
      class="map-view-container"
    >
      <HotelsMap />
    </div>
    <div
      v-else-if="
        !this.$store.state.hotel.showMap && !this.$store.state.hotel.loading
      "
      class="hotel-index-container"
    >
      <div
        v-if="packageJustAdded"
        class="package-added-successfully-parent"
      >
        <div class="package-added-successfully" />
        <span>
          {{ $t('h4h.packageSuccess', {
            package_name: orderItem.package_display_name
          }) }}
        </span>
        <span
          class="pointer"
          @click="packageJustAdded = false"
        >
          <span class="package-success-message" />
        </span>
      </div>

      <H4HBreadcrumbs />

      <div class="purchase-path-nav-parent">
        <div class="purchase-path-nav" />
        <a
          v-if="!hotelIsSelected"
          class="back-to-package"
          @click="goToPackagePath()"
        >{{ $t('h4h.back') }}</a>
        <a
          v-else
          class="back-to-package pointer"
          @click.prevent="deselectSpecifiedHotel"
        >
          {{ $t("h4h.seeAllProperties") }}
        </a>
        <a
          class="mobile-h4h-proceed-to-checkout proceed-to-checkout"
          @click="goToCheckoutPage()"
        >{{ $t('h4h.checkoutStep') }}</a>
        <a
          class="proceed-to-checkout"
          @click="goToCheckoutPage()"
        >{{ $t('h4h.noHotelProceed') }}</a>
      </div>
      <div v-if="!hotelIsSelected">
        <h3 class="hotel-index-header">
          {{ $t("h4h.chooseOptionalAccomodation") }}
        </h3>
        <p class="hotel-index-description">
          {{ $t('h4h.chooseAccomodationDescription', {
            brand_name: brandName
          }) }}
          <a @click="goToCheckoutPage()">{{ $t('h4h.clickHereToContinue') }}</a>
        </p>

        <ContractHotelIndex
          v-if="contractedAvailable"
          :rate="parseFloat(order.exchange_rate)"
          :currency="order.currency"
        />
        <HotelOfferings v-if="contractedAvailable && retailHotelsAllowed" />
        <RetailHotelIndex
          v-if="this.$store.state.hotel.showRetailIndex || !contractedAvailable"
          :rate="parseFloat(order.exchange_rate)"
          :currency="order.currency"
        />
      </div>
      <HotelOverview
        v-if="this.$store.state.hotel.hotel"
        :order="order"
      />
    </div>
  </div>
</template>

<script>
/* global locale Turbolinks*/

import HotelFilter from './retail_hotel_filter'
import Api from '../../cart/cart_api'
import FetchCall from '../../local_fetch_call'
import Hotel from '../../../classes/hotel'
import H4HBreadcrumbs from './h4h_breadcrumb'
import HotelsMap from './hotels_map'
import ContractHotelIndex from './contract_hotel_index'
import HotelOfferings from './hotel_offerings'
import RetailHotelIndex from './retail_hotel_index'
import HotelOverview from '../h4h_rooms/hotel_overview'
import mixin from './hotel_availability'
import { mapMutations, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    HotelFilter,
    H4HBreadcrumbs,
    HotelsMap,
    RetailHotelIndex,
    ContractHotelIndex,
    HotelOfferings,
    HotelOverview,
  },

  mixins: [mixin],

  data() {
    return {
      packageJustAdded: false,
      brandName: window.brand_name,
      loading: false,
      displayIndex: false,
      hotels: [],
      order: {},
      orderItem: {},
      package: {},
      orderHotelId: {
        default: null,
        required: false,
      },
      selectedStay: {
        default: null,
        requried: false,
      },
      roomQty: Number,
    }
  },

  computed: {
    ...mapGetters('hotel', ['getContractedHotels']),
    contractedAvailable() {
      return this.getContractedHotels.length > 0 ? true : false
    },
    tempPackage() {
      let pack = this.package
      pack.purchasable_hotels = this.hotels
      return pack
    },
    retailHotelsAllowed() {
      return this.order.event_hotel_behavior != 'contracted_only' ? true : false
    },

    hotelIsSelected() {
      return this.$store.state.hotel.hotel ? true : false
    },
  },

  created() {
    this.setLoading(true)
    window.history.replaceState(null, null, 'hotels')

    if (
      window.location.pathname.charAt(window.location.pathname.length - 1) ===
      '/'
    ) {
      window.history.replaceState(null, null, '../hotels')
    } else {
      window.history.replaceState(null, null, './hotels')
    }
    this.getOrder()
  },

  updated() {
    this.redirectIfNoPkg()
  },

  methods: {
    ...mapMutations('hotel', [
      'setLoading',
      'updateDestination',
      'updateH4hDestination',
      'updateVenue',
      'updateLatitude',
      'updateH4hLatitude',
      'updateLongitude',
      'updateH4hLongitude',
      'updateCheckInDate',
      'updateCheckOutDate',
      'updateTBDStatus',
      'deselectHotel',
      'showRetailIndex',
      'addHotelToArray',
      'selectHotel'
    ]),

    ...mapMutations('orderItem', ['updateOrderItemId']),

    ...mapMutations('event', ['updateEventLocation']),

    ...mapMutations('packages', ['setPackageId', 'updatePackageQty']),

    deselectSpecifiedHotel() {
      window.history.pushState(null, null, './hotels')

      this.deselectHotel()
    },
    async getHotels() {
      let res = await FetchCall.fetchWithoutLocale(
        `/api/packages/${this.$store.state.packages.packageId}/hotels`,
        'GET',
        null
      )

      this.hotels = res.hotels
      await this.createHotelObject(true)
    },

    getOrder() {
      return Api.getOrder().then((order) => {
        if (order.cart_version == 'h4h') {
          // let startDate = new Date(order.event_start_date)
          // let endDate = new Date(order.event_end_date)
          // startDate = startDate.setDate(startDate.getDate() + 1)
          // if (order.event_start_date == order.event_end_date) {
          //   endDate = endDate.setDate(endDate.getDate() + 2)
          // } else {
          //   endDate = endDate.setDate(endDate.getDate() + 1)
          // }
          this.displayIndex = true
          this.order = order
          this.updateVenue(order.event_venue)
          this.updateDestination(order.event_address)
          this.updateH4hDestination(order.event_h4h_address)
          this.updateLatitude(order.event_latitude)
          this.updateH4hLatitude(order.event_h4h_latitude)
          this.updateLongitude(order.event_longitude)
          this.updateH4hLongitude(order.event_h4h_longitude)
          this.updateCheckInDate(moment(order.event_start_date)._d)
          this.updateCheckOutDate(moment(order.event_end_date)._d)
          this.setItemAndHotels()
          this.updateEventLocation(order.event_location)

          if(order.event_extra_data['date_translate']) {
            if(order.event_extra_data.date_translate == 'TBD') {
              this.updateTBDStatus(true)
            }
          }
        }
      })
    },

    getItemNumber() {
      let pathArray = window.location.href.split('/')
      let pathItemId = pathArray.reverse()[1]
      let itemId = Number(pathItemId)
      return itemId
    },
    redirectIfNoPkg(){
      if(this.order.items.length===0){
        Turbolinks.visit('/packages')
      }
    },

    async setItemAndHotels() {
      let item = this.order.items.find((item) => {
        return item.id == this.getItemNumber()
      })

      if (item) {
        this.orderItem = item
        this.setPackageJustAdded(item.created_at)
        this.setPackageId(item.package_id)
        this.updatePackageQty(item.quantity)
        await this.getHotels()
        if (item.hotel_id) {
          this.checkHotelInCart(item)
        }
      }
    },

    goToPackagePath() {
      const packageId = this.$store.state.packages.packageId
      window.location.href = `/${locale}/packages/${packageId}/path`
    },

    goToCheckoutPage() {
      window.location.href = '/cart/checkout'
    },

    setPackageJustAdded(created_at) {
      let date = new Date()
      let dateCreated = new Date(created_at)

      if (date.getTime() - 15000 < dateCreated.getTime()) {
        this.packageJustAdded = true
        setTimeout(() => {
          this.packageJustAdded = false
        }, 20000)
      }
    },

    checkHotelInCart(item) {
      let hotels = this.getContractedHotels
      let hotel = hotels.find((hotel) => {
        return hotel.qng_id == item.hotel_id
      })
      if (hotel) {
        this.selectHotel(hotel)
        window.history.pushState(hotel.id, null, `hotels#${hotel.id}`)
        window.addEventListener('popstate', (e) => {
          e.state !== null ? this.selectHotel(hotel) : this.selectHotel(null)
        })
      } else if (item.h4h_hotel_attributes.hotel_id) {
        this.fetchH4HHotelInfo(item.h4h_hotel_attributes)
      }
    },

    async fetchH4HHotelInfo(hotelAttributes) {
      moment.locale(locale)
      let checkIn = moment(hotelAttributes.hotel_check_in_date)._d
      let checkOut = moment(hotelAttributes.hotel_check_out_date)._d

      let res = await FetchCall.fetchWithoutLocale(
        '/api/h4h_hotels' +
        `?latitude=${hotelAttributes.hotel_latitude}` +
        `&longitude=${hotelAttributes.hotel_longitude}` +
        `&inDate=${moment(checkIn).format('YYYY-MM-DD')}` +
        `&outDate=${moment(checkOut).format('YYYY-MM-DD')}` +
        `&rooms=${hotelAttributes.room_quantity}`,
        'GET',
        null
      )

      let hotels = res.ArnResponse.Availability.HotelAvailability.Hotel

      let index = hotels
        .map((x) => {
          return x['@HotelID']
        })
        .indexOf(hotelAttributes.hotel_id)
      let hotel = new Hotel(hotels[index])
      await hotel.updateHotelInfo(
        this.order.event_latitude,
        this.order.event_longitude
      )

      // eslint-disable-next-line require-atomic-updates
      hotel.checkIn = checkIn
      // eslint-disable-next-line require-atomic-updates
      hotel.checkOut = checkOut
      // eslint-disable-next-line require-atomic-updates
      hotel.stayDuration = moment(checkOut).diff(checkIn, 'days')

      this.addHotelToArray(hotel)
      this.selectHotel(hotel)
      window.history.pushState(hotel.id, null, `hotels#${hotel.id}`)
      window.addEventListener('popstate', (e) => {
        e.state !== null ? this.selectHotel(hotel) : this.selectHotel(null)
      })
      this.setLoading(false)
    },

    updateOrderCurrency(event){
      this.order.currency = event.target.dataset.currency
      this.order.exchange_rate = event.target.dataset.rate
    },

    updateRoomQty(qty) {
      qty ? (this.roomQty = qty) : null
    },
  },
}
</script>
